import { useState } from 'react';

import { useMutation } from '@tanstack/react-query';

import {
  DocumentUploadBody,
  fetchPostDocumentUpload,
} from '../../../../api/lending/edge';
import { useStateKey } from '../../../../hooks/useStateKey.hook';

export const useUploadBankDocuments = () => {
  const { stateKey } = useStateKey();
  const [isLoading, setIsLoading] = useState(false);

  const { mutateAsync, isLoading: loadingPost } = useMutation({
    mutationFn: ({ body }: { body: DocumentUploadBody }) =>
      fetchPostDocumentUpload({ stateKey: stateKey!, body }),
  });

  const postUploadDocuments = async ({ files }: { files: File[] }) => {
    setIsLoading(true);
    for (const file of files) {
      const body: DocumentUploadBody = {
        document: file,
        document_type: 'bank statement',
      };

      try {
        await mutateAsync({ body });
      } catch (e) {}
    }
    setIsLoading(false);
  };

  return {
    uploadDocuments: postUploadDocuments,
    isLoadingUploadDocuments: isLoading || loadingPost,
  };
};
